import React from 'react';
import Loding from '../Shared/Loding';
import { isError, useQuery } from 'react-query';
import { FaTrashAlt, FaUsers } from 'react-icons/fa';
import useAxios from '../../hooks/useAxios';
import Swal from 'sweetalert2';

const Mangeoders = () => {
   const uesaxios=useAxios()
   
   
    const {data:booking,isLoading,refetch,isError,error } =useQuery('booking',()=>fetch('https://car-manufacture-server-side.onrender.com/bookingall',{
        method:"GET",   
       headers: {
             authorization: `Bearer ${localStorage.getItem('accessToken')}`
         }
 
     }).then(res=>res.json() 
    ))
    refetch()  

  let total=0
  
   if(booking){
    for(let t of booking){
        total=total+t.price
    }
   }
   
  const handleDelete=book=>{
    console.log(book._id)
    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
    }).then((result) => {
        if (result.isConfirmed) {

            uesaxios.delete(`/booking/${book._id}`,{
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`
              }})
                .then(res => {
                    if (res.data.deletedCount > 0) {
                        refetch();
                        Swal.fire({
                            title: "Deleted!",
                            text: "Your file has been deleted.",
                            icon: "success"
                        });
                    }
                })
        }
    });
  }

  if(isLoading){


      return <Loding></Loding>
      }
      if(isError){
        return <p className='text-[20px] text-center'>{error.message}</p>
     }
   
   
    return (
        <div>
        <div className="flex justify-evenly my-4 mx-5">
            <h2 className="text-3xl">All Order</h2>
            <h2 className="text-3xl">Total Order:{booking?.length} </h2>
            <h2 className="text-3xl">Total Price:${total} </h2>
        </div>
        <div className="overflow-x-auto">
            <table className="table table-zebra w-full">
                {/* head */}
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Quantity</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                       booking?.map((book, index) => <tr key={book._id}>
                            <th>{index + 1}</th>
                            <td>{book.Partname
}</td>
                            <td>{book.user}</td>
                            
                            <td>
                               {
                                book.orderQuentey
                               }
                            </td>
                            
                            <td>
                                {  book.transactionId ? <p className='text-primary'>Payment complete</p>  :<button onClick={()=>handleDelete(book)}
                                    
                                    className="btn btn-ghost btn-lg">
                                    <FaTrashAlt className="text-red-600"></FaTrashAlt>
                                </button> }
                            </td>
                           
                        </tr>)
                    }

                </tbody>
            </table>
        </div>
    </div>
    );
};

export default Mangeoders;